export const DESKTOP_IMAGE_SRC = 'https://{src}/m/232x192';
